import Http from '@/services/http';
import {
  SaveRegionalRequest,
  RegionalResponse,
  InstallationFilterType,
  Lookup,
  RegionalInstallationRequest,
} from 'sigma-mappings';

const urls = {
  createRegional: '/regional',
  updateRegional: '/regional',
  getRegional: id => `/regional/${id}`,
  getInstallations: id => `/empresa/${id}/instalacoes`,
};

export default {
  /**
   * Salva os dados da regional
   * @param {*} regional
   */
  saveRegional(regional) {
    const http = new Http({
      errorHandling: {
        responseMessageParams: () => ({
          NomeEmpresa: regional.companyName,
        }),
      },
    });
    if (regional.id) {
      return http.put(
        urls.updateRegional,
        new SaveRegionalRequest(regional),
      );
    }
    return http.post(
      urls.createRegional,
      new SaveRegionalRequest(regional),
    );
  },
  /**
   * Obtem a regional a partir do id
   * @param {*} regionalId id da regional
   */
  getRegional(regionalId) {
    const http = new Http();
    return http.get(urls.getRegional(regionalId))
      .then(({ data }) => new RegionalResponse(data));
  },
  /**
   * Obtem a lista de instalações de acordo com o id da empresa
   * @param {*} companyId id da empresa
   */
  getInstallationsWithoutRegionalByCompanyId(companyId) {
    const http = new Http();
    const params = new RegionalInstallationRequest({
      installationFilterType: InstallationFilterType.WITHOUT_REGIONAL,
    });
    return http.get(
      urls.getInstallations(companyId),
      { params },
    )
      .then(({ data }) => data.map(item => new Lookup(item)));
  },
};
